/**
 * BannerImage — the top banner (BANNER_IMAGE).
 *
 * Decorative background image (360×220, full-bleed) with BE-configurable
 * title + subtitle overlaid on the left. Design ratio 360:220 → aspect-[18/11].
 */
import { BannerImageData } from '../../api/types'

interface Props {
  data: BannerImageData
}

export function BannerImage({ data }: Props) {
  return (
    <div className="relative aspect-[18/11] w-full overflow-hidden">
      <img
        src={data.imageUrl}
        alt=""
        className="absolute inset-0 h-full w-full object-cover"
      />
      {/* Text column capped at 55% so the title/subtitle clear the scroll
          illustration on the right of the image (was 70%, which overlapped). */}
      <div className="absolute inset-0 flex max-w-[55%] flex-col justify-center gap-1 px-4">
        <h1 className="bg-clip-text text-headingSmall text-transparent [background-image:linear-gradient(90deg,var(--gradient-text-gradient-secondary-stops))]">
          {data.title}
        </h1>
        <p className="text-bodySmall text-textPrimary">{data.subtitle}</p>
      </div>
    </div>
  )
}

export default BannerImage
